/* eslint-disable no-undef */
import { Client } from '../../../types/api';
import { StadiumFanAnalytics, AnalyticsInput } from '../../../types/inVenue';
import useAnalytics from './useAnalytics';
// import { decimal } from '../../../utils/formatters';

const useAgeBreakdown = ({
    rightsholder,
    season,
    client,
    gameDates,
    sectionIds,
}: Omit<AnalyticsInput, 'groupBy' | 'clientId'> & { client: Client }) => {
    const { data: analytics, isLoading } = useAnalytics({
        clientId: client.id,
        rightsholder,
        season,
        gameDates,
        sectionIds,
        groupBy: ['gender', 'ageGroup'],
    });

    const data = (analytics || [])
        .sort((a, b) => {
            const [aMinAge] = a.ageGroup.split('-');
            const [bMinAge] = b.ageGroup.split('-');
            return parseInt(aMinAge) - parseInt(bMinAge);
        })
        .reduce(
            (acc: any, curr: StadiumFanAnalytics) => {
                if (!acc.labels.includes(curr.ageGroup)) {
                    acc.labels.push(curr.ageGroup);
                }
                const { gender } = curr;
                if (gender.toLocaleLowerCase() === 'male') {
                    acc.datasets[1].data.push(curr.fanCount);
                } else {
                    acc.datasets[0].data.push(curr.fanCount);
                }
                return acc;
            },
            {
                labels: [],
                datasets: [
                    {
                        label: 'Females',
                        data: [],
                        backgroundColor: client.secondaryColor,
                    },
                    {
                        label: 'Males',
                        data: [],
                        backgroundColor: client.primaryColor,
                    },
                ],
            },
        );

    return { data, isLoading };
};

export default useAgeBreakdown;
